<template>
  <div v-if="emkt.leaveSpaceForFullScreen" style="height: 35px; visibility: hidden;">占位</div>
</template>

<script>
  export default {
    name: 'FooterPlaceholder'
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// FooterPlaceholder.vue?e2583b50